type HandlerMap<S> = Record<string, (state: S, action: any) => S | null | undefined>;

function createReducer<S>(
  initialState: S,
  handlers: HandlerMap<S> = {},
): (state?: S, action?: Action<any>) => S {
  return (state = initialState, action: any = { type: '@@INIT' }) => {
    const handler = action?.type && handlers ? handlers[action.type] : undefined;

    if (!handler) {
      return state;
    }

    const nextState = handler(state, action);

    return nextState ?? state;
  };
}

export default createReducer;
